import React from "react";

const Subject = ({ subject }: { subject: any }) =>
    !!subject ? <span className="activity-item-subject">
        {subject.name}
    </span> : null


export default Subject;